module.exports = __webpack_public_path__ + "img/mannul_news_editdelete.485a2d41.png";